import { Listing } from 'graphql/types'
import logger from 'lib/logger'

export const openCondominiumPageEvent = (condominium: string) => {
  return logger.action('coverage-condominium-open', { condominium })
}

export const breadcrumbEvent = (label: string, url: string) =>
  logger.action('covarage-area-breadcrumb', {
    label,
    url,
  })

export const heroCtaButtonClickEvent = (url: string) => {
  return logger.action('coverage-condominium-search-button', { url })
}

export const condominiumDataCardButtonEvent = (url: string, label: string) =>
  logger.action('coverage-condominium-card-search-button', {
    url,
    label,
  })

export const condominiumTagsButtonEvent = () =>
  logger.action('coverage-condominium-tags-button')

export const condominiumTagsCloseModalEvent = () =>
  logger.action('coverage-condominium-tags-closeModal')

export const featureListingEvent = ({
  condominium,
  url,
  listing,
}: {
  condominium: string
  url: string
  listing: Listing
}) => {
  return logger.action('coverage-condominium-feature-listing', {
    condominium,
    url,
    listingId: listing?.id,
    ...listing,
  })
}

export const moreListingsButtonEvent = (condominium: string, url: string) => {
  return logger.action('coverage-condominium-more-listings-button', {
    condominium,
    url,
  })
}

export const condominiumNeighborhoodButtonEvent = (url: string) =>
  logger.action('coverage-condominium-neighborhood-button', {
    url,
  })

export const neighborhoodCondominiumEvent = ({
  url,
  label,
}: {
  url: string
  label: string
}) => {
  return logger.action('coverage-condominium-condominiums-link', {
    url,
    label,
  })
}

export const neighborhoodCondominiumCollapseEvent = (
  condominium: string,
  label: string,
) => {
  return logger.action('coverage-condominium-condominiums-links-open', {
    condominium,
    label,
  })
}

export const headerCtaEvent = () => logger.action('buyer-landing-header-cta')
